import { createAction, props } from '@ngrx/store';

import {
  CreateDraftCashSettlementRequest,
  CreateDraftCashSettlementResponse
} from '../models/cash-settlement-create.model';
import {
  CashSettlementDetailResponse,
  SubmitTransferEvidenceCashSettlementRequest
} from '../models/cash-settlement-detail.model';
import { CashSettlementListSearchCriteria } from '../models/cash-settlement-list.model';

export const cashSettlementAction = {
  cashSettlementListRequest: createAction(
    '[Cash Settlement] cash settlement list request',
    props<{ payload: CashSettlementListSearchCriteria }>()
  ),
  cashSettlementListResponse: createAction(
    '[Cash Settlement] cash settlement list response',
    props<{ response: any }>()
  ),
  viewCashSettlementRequest: createAction(
    '[Cash Settlement] cash settlement detail request',
    props<{ cashSettlementNo: string }>()
  ),
  viewCashSettlementResponse: createAction(
    '[Cash Settlement] cash settlement detail response',
    props<{ response: CashSettlementDetailResponse }>()
  ),
  resetViewCashSettlementResponse: createAction('[Cash Settlement] reset cash settlement detail response'),
  cashSettlementCreateDraftRequest: createAction('[Cash Settlement] cash settlement create draft request'),
  cashSettlementCreateDraftResponse: createAction(
    '[Cash Settlement] cash settlement create draft response',
    props<{ response: CreateDraftCashSettlementResponse }>()
  ),
  cashSettlementCreateDraftClear: createAction('[Cash Settlement] cash settlement create draft clear'),
  cashSettlementSubmitDraftRequest: createAction(
    '[Cash Settlement] cash settlement submit draft request',
    props<{ payload: CreateDraftCashSettlementRequest }>()
  ),
  cashSettlementSubmitDraftResponse: createAction(
    '[Cash Settlement] cash settlement submit draft response',
    props<{ response: CreateDraftCashSettlementResponse }>()
  ),
  cashSettlementSubmitDraftClear: createAction('[Cash Settlement] cash settlement submit draft clear'),
  cashSettlementSubmitTransferEvidenceRequest: createAction(
    '[Cash Settlement] cash settlement submit transfer evidence request',
    props<{ payload: SubmitTransferEvidenceCashSettlementRequest }>()
  ),
  cashSettlementSubmitTransferEvidenceResponse: createAction(
    '[Cash Settlement] cash settlement submit transfer evidence response',
    props<{ response: CreateDraftCashSettlementResponse }>()
  ),
  cashSettlementSubmitTransferEvidenceClear: createAction(
    '[Cash Settlement] cash settlement submit transfer evidence clear'
  )
};
